import { Component, ChangeDetectionStrategy, input } from '@angular/core';

@Component({
  selector: 'widget-durum-kart',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="durum-kart" [style.border-left-color]="renk()">
      @if (simge()) {
        <span class="simge" [style.color]="renk()">{{ simge() }}</span>
      }
      <div class="icerik">
        <div class="baslik">{{ baslik() }}</div>
        @if (aciklama()) {
          <div class="aciklama">{{ aciklama() }}</div>
        }
      </div>
    </div>
  `,
  styles: [`
    :host { display: block; }
    .durum-kart {
      display: flex; align-items: center; gap: 10px;
      padding: 8px 12px; border-radius: 8px;
      background: var(--py-arkaplan-ikincil, rgba(255,255,255,0.04));
      border-left: 4px solid #1890ff;
      transition: transform 0.2s, box-shadow 0.2s;
      &:hover { transform: translateY(-1px); box-shadow: 0 2px 8px rgba(0,0,0,0.15); }
    }
    .simge { font-size: 1.4em; flex-shrink: 0; }
    .icerik { min-width: 0; flex: 1; }
    .baslik {
      font-size: 0.9em; font-weight: 600;
      color: var(--py-metin, #e0e0e0);
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
    .aciklama {
      font-size: 0.75em; margin-top: 2px;
      color: var(--py-metin-ikincil, #aaa);
      white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    }
  `],
})
export class DurumKartComponent {
  simge = input('');
  baslik = input('');
  aciklama = input('');
  renk = input('#1890ff');
}
